import {ChatMessagesPage, MessageCursor} from '../contracts/chat-message-page.interface';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ChatHistoryService {
  constructor(private http: HttpClient) {}

  getLatest(
    conversationId: number,
    limit = 50,
    beforeCursor?: MessageCursor
  ) {
    let params: any = { limit };

    if (beforeCursor) {
      params['cursorBeforeId'] = beforeCursor.id;
      params['cursorBeforeCreationDate'] = beforeCursor.creationDate;
    }

    return this.http.get<ChatMessagesPage>(
      `/conversations/${conversationId}/messages/latest`,
      { params }
    );
  }

  getContext(
    conversationId: number,
    limit = 50,
    beforeCursor?: MessageCursor,
    afterCursor?: MessageCursor,
    anchorMessageId?: number
  ) {
    let params: any = { limit };

    if (beforeCursor) {
      params['cursorBeforeId'] = beforeCursor.id;
      params['cursorBeforeCreationDate'] = beforeCursor.creationDate;
    }

    if (afterCursor) {
      params['cursorAfterId'] = afterCursor.id;
      params['cursorAfterCreationDate'] = afterCursor.creationDate;
    }

    if (anchorMessageId) {
      params['anchorMessageId'] = anchorMessageId;
    }

    return this.http.get<ChatMessagesPage>(
      `/conversations/${conversationId}/messages/context`,
      { params }
    );
  }
}

